import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider.js';
import { ProtectedRoute } from './auth/ProtectedRoute.js';
import { AppLayout } from './components/AppLayout.js';
import { SignIn } from './pages/SignIn.js';
import { Calculate } from './pages/Calculate.js';
import { Audit } from './pages/Audit.js';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/calculate" element={<Calculate />} />
            {/* /bulk merged into the unified calculator; redirect old links. */}
            <Route path="/bulk" element={<Navigate to="/calculate" replace />} />
            <Route path="/audit" element={<Audit />} />
            <Route index element={<Navigate to="/calculate" replace />} />
            <Route path="*" element={<Navigate to="/calculate" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
